import { CommonModule } from '@angular/common';
import { Component, computed, inject, model } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { shared } from '@tig-dpqa-cloud/contract-backend-common';

import { MultiSelectComponent } from '../../multi-select/multi-select.component';

@Component({
  selector: 'dpqa-status-picker',
  imports: [CommonModule, MultiSelectComponent, TranslatePipe],
  templateUrl: './status-picker.component.html',
  styleUrl: './status-picker.component.less',
})
export class StatusPickerComponent {
  private translateService = inject(TranslateService);
  status = model.required<(shared.SlideScanGeneralQcStatusType | 'NONE')[]>();

  public statusToDisplay = computed(() => {
    const status = this.status();

    if (status.length === 1 && status[0] === 'NONE') {
      return [];
    }

    return status;
  });

  statuses: { key: string; value: shared.SlideScanGeneralQcStatusType }[] = shared.SlideScanGeneralQcStatus.options.map(
    (status) => ({
      key: this.translateService.instant(`FILTER_BAR.STATUS.${status}`),
      value: status,
    }),
  );

  handleUpdateValue(e: (shared.SlideScanGeneralQcStatusType | 'NONE')[]) {
    if (e.length === 0) {
      this.status.set(['NONE']);
      return;
    }

    this.status.set(e);
  }
}
